import { Locale } from "./i18n";

export default {
    // Changed display name and code to German
    display: "Deutsch",
    code: "de",
    translation: {
        // Basic shape translations
        "arc.angle": "Winkel",
        "arc.start": "Start",
        "axis.x": "X-Achse",
        "axis.y": "Y-Achse",
        "axis.z": "Z-Achse",
        "body.arc": "Bogen",
        "body.bolean": "Boolesch",
        "body.box": "Quader",
        "body.circle": "Kreis",
        "body.face": "Fläche",
        "body.fuse": "Verschmelzung",
        "body.imported": "Importiert",
        "body.line": "Linie",
        "body.polygon": "Polygon",
        "body.prism": "Prisma",
        "body.rect": "Rechteck",
        "body.revol": "Rotation",
        "body.sweep": "Sweep",
        "body.wire": "Draht",
        "box.dx": "Länge",
        "box.dy": "Breite",
        "box.dz": "Höhe",
        "body.editableShape": "Bearbeitbare Form",
        "body.meshNode": "Netzknoten",
        "body.multiShape": "Mehrfachform",
        "circle.center": "Mittelpunkt",
        "circle.radius": "Radius",

        // Commands translations
        "command.arc": "Bogen",
        "command.array": "Array",
        "command.bezier": "Bézier",
        "command.boolean.common": "Gemeinsam",
        "command.boolean.cut": "Schneiden",
        "command.boolean.fuse": "Verschmelzen",
        "command.box": "Quader",
        "command.break": "Unterbrechen",
        "command.circle": "Kreis",
        "command.copy": "Kopieren",
        "command.delete": "Löschen",
        "command.document.new": "Neues Zeichnung",
        "command.document.open": "Zeichnung hochladen",
        "command.document.save": "Speichern",
        "command.document.saveAs": "Speichern unter",
        "command.document.saveToFile": "In Datei speichern",
        "command.export": "Exportieren",
        "command.faceable.isFace": "Fläche",
        "command.fuse": "Verschmelzen",
        "command.import": "Importieren",
        "command.line.isConnected": "Verbunden",
        "command.line": "Linie",
        "command.mirror": "Spiegeln",
        "command.mode.repeat": "Wiederholen",
        "command.move": "Verschieben",
        "command.newFolder": "Neuer Ordner",
        "command.newGroup": "Neue Gruppe",
        "command.offset": "Versatz",
        "command.polygon": "Polygon",
        "command.prism": "Prisma",
        "command.rect": "Rechteck",
        "command.redo": "Wiederherstellen",
        "command.revol": "Rotieren",
        "command.rotate": "Drehen",
        "command.section": "Schnitt",
        "command.split": "Teilen",
        "command.sweep": "Sweep",
        "command.thickSolid": "Dickwandiger Körper",
        "command.toFace": "Zu Fläche",
        "command.toWire": "Zu Draht",
        "command.trim": "Trimmen",
        "command.undo": "Rückgängig",

        // Common terms
        "common.angle": "Winkel",
        "common.back": "Zurück",
        "common.cancel": "Abbrechen",
        "common.clone": "Klonen",
        "common.color": "Farbe",
        "common.confirm": "Bestätigen",
        "common.general": "Allgemein",
        "common.length": "Länge",
        "common.material": "Material",
        "common.matrix": "Matrix",
        "common.name": "Name",
        "common.normal": "Normal",
        "common.opacity": "Transparenz",
        "common.thickness": "Dicke",
        "common.type": "Typ",

        // Entity related
        "entity.editable": "Bearbeitbare Entität",
        "entity.parameter": "Parameter-Entität",

        // Error messages
        "error.default:{0}": "Fehler: {0}",
        "error.input.cannotInputANumber":
            "Überlappung mit Referenzpunkt, 1 Zahl kann nicht eingegeben werden",
        "error.input.invalidNumber": "Bitte geben Sie eine gültige Zahl ein, getrennt durch ,",
        "error.input.threeNumberCanBeInput": "Referenzpunkt ist leer, nur 3 Zahlen können eingegeben werden",
        "error.input.unsupportedInputs": "Überschreitet die maximale Anzahl an Eingaben",
        "error.import.unsupportedFileType:{0}": "Nicht unterstützter Dateityp: {0}",
        "error.export.noNodeCanBeExported": "Kein Knoten kann exportiert werden",

        // File and home related
        "file.format": "Format",
        "home.recent": "Zuletzt verwendet",
        "home.welcome": "Willkommen bei LuminiCAD",

        // Items and tools
        "items.header": "Elemente",
        "items.tool.delete": "Löschen",
        "items.tool.expandAll": "Alle erweitern",
        "items.tool.newFolder": "Neuer Ordner",
        "items.tool.unexpandAll": "Alle reduzieren",

        // Line properties
        "line.end": "Ende",
        "line.start": "Start",
        "line.type.line": "Linie",
        "line.type.xline": "X-Linie",

        // Material properties
        "material.texture.image": "Bild",
        "material.texture.rotation": "Rotation",
        "material.texture.wrapS": "Wrap S",
        "material.texture.wrapT": "Wrap T",
        "material.texture.repeat": "Wiederholen",
        "material.texture.offset": "Versatz",
        "material.map": "Textur",
        "material.specular": "Spiegelung",
        "material.shininess": "Glanz",
        "material.emissive": "Emission",
        "material.specularMap": "Spiegelungskarte",
        "material.normalMap": "Normalkarte",
        "material.bumpMap": "Reliefkarte",
        "material.roughnessMap": "Rauhheitskarte",
        "material.emissiveMap": "Emissionskarte",
        "material.metalness": "Metallisch",
        "material.metalnessMap": "Metallkarte",
        "material.roughness": "Rauhheit",

        // Model and operations
        "model.visible": "Sichtbar",
        "operate.pickCircleCenter": "Mittelpunkt wählen, ESC-Taste zum Abbrechen",
        "operate.pickFistPoint": "Ersten Punkt wählen, ESC-Taste zum Abbrechen",
        "operate.pickNextPoint": "Nächsten Punkt wählen, ESC-Taste zum Abbrechen",
        "operate.pickRadius": "Radius eingeben, ESC-Taste zum Abbrechen",
        "polygon.points": "Punkte",

        // Prompts and messages
        "prompt.default":
            "Mittlere Maustaste zum Verschieben der Ansicht, Umschalt + mittlere Taste zum Drehen der Ansicht, mittlere Taste zum Zoomen",
        "prompt.deleteDocument{0}": "Möchten Sie {0} löschen?",
        "prompt.polygon.close": "Schließen",
        "prompt.saveDocument{0}": "Möchten Sie die Änderungen an {0} speichern?",
        "prompt.select.edges": "Bitte Kanten auswählen",
        "prompt.select.faces": "Bitte Flächen auswählen",
        "prompt.select.models": "Bitte Modelle auswählen",
        "prompt.select.noModelSelected": "Kein Modell ausgewählt",
        "prompt.select.shape": "Bitte Form auswählen",
        "prompt.select.vertexs": "Bitte Scheitelpunkte auswählen",
        "prompt.select.wires": "Bitte Drähte auswählen",

        // Properties and UI elements
        "properties.group.transform": "Transformation",
        "properties.header": "Eigenschaften",
        "properties.multivalue": "Mehrfachwert",
        "rect.dx": "Länge",
        "rect.dy": "Breite",

        // Ribbon interface
        "ribbon.group.boolean": "Boolesch",
        "ribbon.group.converter": "Konverter",
        "ribbon.group.draw": "Zeichnen",
        "ribbon.group.importExport": "Import/Export",
        "ribbon.group.modify": "Modifizieren",
        "ribbon.group.selection": "Auswahl",
        "ribbon.group.tools": "Werkzeuge",
        "ribbon.group.workingPlane": "Arbeitsebene",
        "ribbon.tab.draw": "Zeichnen",
        "ribbon.tab.file": "Datei",
        "ribbon.tab.startup": "Editor",

        // Snap options
        "snap.center": "Mittelpunkt",
        "snap.end": "Endpunkt",
        "snap.intersection": "Schnittpunkt",
        "snap.mid": "Mittelpunkt",
        "snap.perpendicular": "Senkrecht",
        "snap.nearest": "Nächster Punkt",

        // Toast messages
        "toast.command.{0}excuting": "Befehl {0} wird ausgeführt",
        "toast.converter.error": "Konvertierungsfehler",
        "toast.converter.invalidColor": "Die Farbe ist ungültig",
        "toast.delete{0}Objects": "{0} Objekte gelöscht",
        "toast.document.noActived": "Kein Dokument aktiv",
        "toast.document.saved": "Dokument gespeichert",
        "toast.downloading": "Wird heruntergeladen",
        "toast.excuting{0}": "Führe {0} aus",
        "toast.fail": "Fehlgeschlagen",
        "toast.read.error": "Lesefehler",
        "toast.select.noSelected": "Nichts ausgewählt",
        "toast.success": "Erfolgreich",

        // Transform options
        "transform.rotation": "Rotation",
        "transform.scale": "Skalierung",
        "transform.translation": "Translation",
        "vertex.point": "Punkt",

        // Working plane
        "workingPlane.alignToPlane": "An Ebene ausrichten",
        "workingPlane.set": "Arbeitsebene festlegen",
        "test.performace": "Leistungstest",

        // AI Chat
        "chat.title": "KI-Assistent",
        "chat.placeholder": "Geben Sie Ihre CAD-Anfrage ein...",
        "command.ai.chat": "KI-Chat",

        // Settings page translations
        "settings.title": "Einstellungen",
        "settings.profile": "Profil",
        "settings.appearance": "Erscheinungsbild",
        "settings.shortcuts": "Tastenkombinationen",
        "settings.notifications": "Benachrichtigungen",
        "settings.privacy": "Datenschutz",
        "settings.advanced": "Erweitert",

        "settings.profile.name": "Vollständiger Name",
        "settings.profile.email": "E-Mail-Adresse",
        "settings.profile.bio": "Biografie",
        "settings.profile.namePlaceholder": "Geben Sie Ihren Namen ein",
        "settings.profile.emailPlaceholder": "Geben Sie Ihre E-Mail ein",
        "settings.profile.bioPlaceholder": "Erzählen Sie uns von sich",

        "settings.theme.title": "Design",
        "settings.theme.light": "Hell",
        "settings.theme.dark": "Dunkel",

        // Working plane
        "workingPlane.toggleDynamic": "Dynamische Arbeitsebene aktivieren/deaktivieren",
        "workingPlane.fromSection": "Arbeitsebene aus Schnitt erstellen",
        "body.cylinder": "Zylinder",
        "body.cone": "Kegel",
        "body.sphere": "Kugel",
        "body.ellipse": "Ellipse",
        "body.pyramid": "Pyramide",
        "ellipsoid.radiusX": "Ellipsoid Radiusx",
        "ellipsoid.radiusY": "Ellipsoid Radiusy",
        "ellipsoid.radiusZ": "Ellipsoid Radiusz",
        "ellipse.majorRadius": "Ellipse Majorradius",
        "ellipse.minorRadius": "Ellipse Minorradius",
        "command.pyramid": "Pyramide",
        "command.cylinder": "Zylinder",
        "command.cone": "Kegel",
        "command.sphere": "Kugel",
        "command.ellipse": "Ellipse",
        "command.chamfer": "Abrunden",
        "command.copySubShape": "Kopieren",
        "command.explode": "Explodieren",
        "command.fillet": "Abrunden",
        "command.removeFeature": "Entfernen",
        "command.removeSubShapes": "Entfernen",
        "command.toShell": "Schale",
        "command.toSolid": "Festkörper",
        "ribbon.group.2d": "2D",
        "ribbon.group.3d": "3D",
        "ribbon.group.other": "Andere",
        "ribbon.tab.tools": "Werkzeuge",
        "statusBar.snap": "Snap",
        "statusBar.tracking": "Tracking",
        // Labels for Shapes List panel in chat header (German)
        "chat.shapesList.currentDocument": "Formen im aktuellen Dokument",
        "chat.shapesList.allDocuments": "Formen aus anderen Dokumenten",
        "chat.shapesList.noDocument": "Kein aktives Dokument zum Auflisten von Formen.",
        "chat.shapesList.noStorage": "Speicher nicht verfügbar, um Dokumente abzurufen.",
        "chat.shapesList.errorLoading": "Fehler beim Laden der Formenliste.",
    },
} satisfies Locale;
